const TipoMensagem = {
  Texto: 1,
  Audio: 2,
  Video: 3,
  Documento: 4,
  Imagem: 5,
  Log: 6,
  Interna: 7,
  Localizacao: 8,
  Link: 9,
  Template:10
};

export default TipoMensagem;
